export default "__VITE_ASSET__B7tlm7Us__"